import check from "./check";

const Can = props => {
  return check(props.perform, props.customerCode) ?
    props.yes() :
    props.no()
};

Can.defaultProps = {
  yes: () => null,
  no: () => null
};

export default Can